var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_219_1833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_219_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9933 13.9043L12.3622 11.0486C12.2017 10.8721 11.9451 10.7598 11.7044 10.7598L9.31393 10.7598C9.07328 10.7598 8.88078 10.9523 8.88078 11.1929C8.88078 11.4336 9.07328 11.6261 9.31393 11.6261H11.7365L14.3676 14.5139C14.3676 14.53 14.3516 14.53 14.3516 14.53L0.891104 14.53L0.875071 14.4979L3.52225 11.6261H5.91273C6.15338 11.6261 6.34588 11.4336 6.34588 11.193C6.34588 10.9523 6.15338 10.7598 5.91273 10.7598H3.52225C3.26557 10.7598 3.02491 10.8721 2.86448 11.0486L0.233345 13.9044C-0.0233379 14.1771 -0.0714952 14.5782 0.104975 14.9312C0.26541 15.236 0.602311 15.4125 0.939211 15.4125H14.2874C14.6243 15.4125 14.9612 15.236 15.1216 14.9312C15.3142 14.5942 15.2501 14.1931 14.9934 13.9044L14.9933 13.9043Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3993 6.39595C5.22283 6.6366 5.11049 6.94144 5.11049 7.26231C5.11049 8.09654 5.78429 8.7704 6.61858 8.7704C6.76298 8.7704 6.90739 8.73833 7.0357 8.70621V12.4283C7.0357 12.7492 7.29238 13.0059 7.61325 13.0059C7.93412 13.0059 8.1908 12.7492 8.1908 12.4283L8.19085 8.72226C8.31922 8.75432 8.46357 8.78644 8.60797 8.78644C9.44221 8.78644 10.1161 8.11264 10.1161 7.27835C10.1161 6.95748 10.0038 6.65264 9.82725 6.41199C10.1321 6.10715 10.3246 5.70606 10.3246 5.24079C10.3246 4.61508 9.97166 4.08568 9.45822 3.81292C9.42621 2.8022 8.60794 2 7.61322 2C6.6185 2 5.8003 2.80217 5.76822 3.79687C5.25485 4.06958 4.90186 4.61508 4.90186 5.22474C4.90186 5.69002 5.0944 6.09111 5.39919 6.39595H5.3993Z",
    fill: "#0B5838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.c44c6a858bff8fbae3dccdef77cad9b0.svg";
export { ForwardRef as ReactComponent };